const getDefaultState = () => {
    return {}
}

const BookCatalogModule = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {},
    actions: {},
}

export default BookCatalogModule
